import { forwardRef } from "react";

import { clsx } from "clsx";

import type { InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, id, ...props }, ref) => {
    const inputId = id ?? `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <div className="space-y-2">
        {label ? (
          <label
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            htmlFor={inputId}
          >
            {label}
          </label>
        ) : null}
        <input
          ref={ref}
          className={clsx(`input`, error && `border-red-500 focus-visible:ring-red-500`, className)}
          id={inputId}
          {...props}
        />
        {error || helperText ? (
          <p className={clsx(`text-sm`, error ? `text-red-600 dark:text-red-400` : `text-gray-500 dark:text-gray-400`)}>
            {error ?? helperText}
          </p>
        ) : null}
      </div>
    );
  },
);

Input.displayName = `Input`;
